import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { useTranslation } from 'react-i18next';
import { initAffiliateTracking } from './lib/affiliateTracker';
import i18n from './i18n';
import HomePage from './pages/HomePage';
import QuizPage from './pages/QuizPage';
import ResultsPage from './pages/ResultsPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import About from './pages/About';
import MesafeliSatisPage from './pages/MesafeliSatisPage';
import TeslimatVeIade from './pages/TeslimatVeIade';
import AffiliatePage from './pages/AffiliatePage';

// ScrollToTop component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const { i18n: i18nextInstance } = useTranslation();
  
	useEffect(() => {
		initAffiliateTracking(); // safe to call on every render – only acts when ?t= is present
	}, []);

  useEffect(() => {
    // Detect browser language
    const browserLanguage = navigator.language || navigator.userLanguage; // e.g., 'fr-FR'
    const languageCode = browserLanguage.split('-')[0]; // 'fr'
    const supportedLanguages = ['en', 'es', 'fr', 'de', 'it', 'pt', 'nl', 'tr'];
    const lng = supportedLanguages.includes(languageCode) ? languageCode : 'en';
    
    // Set language globally
    i18nextInstance.changeLanguage(lng);
  }, [i18nextInstance]);

  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/quiz/:quizId" element={<QuizPage />} />
          <Route path="/results/:uid" element={<ResultsPage />} />
          <Route path="/joseph" element={<AdminLogin />} />
          <Route path="/joseph/dashboard" element={<AdminDashboard />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
		  <Route path="/about" element={<About />} />
		  <Route path="/mesafeli-satis" element={<MesafeliSatisPage />} />
		  <Route path="/teslimat-ve-iade" element={<TeslimatVeIade />} />
		  <Route path="/affiliate" element={<AffiliatePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </>
  );
}

export default App;